// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Plans page ────────────────────────────────────────── */
.plans-page {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: clamp(32px, 5vw, 64px) clamp(16px, 4vw, 40px);
    box-sizing: border-box;
}

.plans-header {
    text-align: center;
    margin-bottom: 48px;
}

.plans-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 300;
    color: #f4f4f4;
    margin: 0 0 12px;
    letter-spacing: 0.01em;
}

.plans-subtitle {
    font-size: 0.9375rem;
    color: #a0a0a0;
    margin: 0;
    line-height: 1.6;
}

.plans-error {
    text-align: center;
    color: #ff8080;
    background: rgba(255, 80, 80, 0.1);
    border: 1px solid rgba(255, 80, 80, 0.25);
    border-radius: 10px;
    padding: 12px 20px;
    margin-bottom: 32px;
    font-size: 0.9rem;
}

/* ── Plan grid ─────────────────────────────────────────── */
.plans-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    align-items: start;
}

/* ── Plan card ─────────────────────────────────────────── */
.plan-card {
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.09);
    background: linear-gradient(
        168deg,
        rgba(54, 54, 58, 0.92) 0%,
        rgba(28, 28, 32, 0.97) 100%
    );
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4);
    padding: 28px 24px 24px;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    position: relative;
}

.plan-card:hover {
    border-color: rgba(255, 255, 255, 0.16);
    box-shadow: 0 20px 56px rgba(0, 0, 0, 0.5);
}

.plan-card--highlighted {
    border-color: rgba(192, 159, 83, 0.55);
    background: linear-gradient(
        168deg,
        rgba(64, 58, 42, 0.95) 0%,
        rgba(32, 28, 18, 0.98) 100%
    );
    box-shadow:
        0 20px 56px rgba(0, 0, 0, 0.5),
        0 0 0 1px rgba(192, 159, 83, 0.2);
}

.plan-card--highlighted::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 48%;
    height: 3px;
    border-radius: 0 0 8px 8px;
    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.9), transparent);
}

.plan-card--highlighted:hover {
    border-color: rgba(192, 159, 83, 0.75);
}

/* Labels row (popular / badge) */
.plan-card__labels {
    display: flex;
    gap: 8px;
    min-height: 24px;
    margin-bottom: 12px;
}

.plan-card__popular {
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #c0a053;
    background: rgba(192, 159, 83, 0.12);
    border: 1px solid rgba(192, 159, 83, 0.3);
    border-radius: 20px;
    padding: 3px 10px;
    display: inline-block;
}

.plan-card__badge {
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #7dd69e;
    background: rgba(80, 200, 120, 0.1);
    border: 1px solid rgba(80, 200, 120, 0.25);
    border-radius: 20px;
    padding: 3px 10px;
    display: inline-block;
}

.plan-card__name {
    font-size: 1.25rem;
    font-weight: 400;
    color: #f0f0f0;
    margin: 0 0 14px;
    letter-spacing: 0.01em;
}

.plan-card__pricing {
    display: flex;
    align-items: baseline;
    gap: 4px;
    margin-bottom: 4px;
}

.plan-card__price {
    font-size: 2rem;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: -0.02em;
    line-height: 1;
}

.plan-card__period {
    font-size: 0.875rem;
    color: #888;
    font-weight: 400;
}

.plan-card__subtext {
    font-size: 0.8125rem;
    color: #c0a053;
    margin: 4px 0 12px;
    font-weight: 500;
}

.plan-card__description {
    font-size: 0.85rem;
    color: #909090;
    margin: 8px 0 20px;
    line-height: 1.55;
}

/* Features list */
.plan-card__features {
    list-style: none;
    margin: 0 0 24px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
}

.plan-card__feature {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    font-size: 0.875rem;
    color: #c8c8c8;
    line-height: 1.45;
}

.plan-card__check {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin-top: 1px;
    color: #c0a053;
}

/* CTA button */
.plan-card__cta {
    width: 100%;
    padding: 13px 20px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.06);
    color: #e8e8e8;
    font-size: 0.9375rem;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
    box-sizing: border-box;
    margin-top: auto;
}

.plan-card__cta:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.25);
}

.plan-card__cta:active:not(:disabled) {
    transform: translateY(1px);
}

.plan-card__cta:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.plan-card__cta--primary {
    border-color: rgba(192, 159, 83, 0.55);
    background: linear-gradient(
        180deg,
        rgba(192, 159, 83, 0.28) 0%,
        rgba(160, 130, 65, 0.18) 100%
    );
    color: #faf6ee;
    font-weight: 600;
    box-shadow:
        0 8px 24px rgba(0, 0, 0, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.plan-card__cta--primary:hover:not(:disabled) {
    border-color: rgba(192, 159, 83, 0.8);
    background: linear-gradient(
        180deg,
        rgba(192, 159, 83, 0.38) 0%,
        rgba(160, 130, 65, 0.26) 100%
    );
    box-shadow:
        0 10px 28px rgba(0, 0, 0, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

/* ── Footer ────────────────────────────────────────────── */
.plans-footer {
    text-align: center;
    margin-top: 40px;
    font-size: 0.8125rem;
    color: #686868;
    line-height: 1.6;
}

/* ── Checkout page ─────────────────────────────────────── */
.checkout-page {
    width: 100%;
    max-width: 780px;
    margin: 0 auto;
    padding: clamp(32px, 5vw, 56px) clamp(16px, 4vw, 40px);
    box-sizing: border-box;
}

.checkout-header {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 32px;
    flex-wrap: wrap;
}

.checkout-back {
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    color: #a0a0a0;
    font-size: 0.875rem;
    font-family: inherit;
    padding: 8px 14px;
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.15s ease, border-color 0.15s ease;
}

.checkout-back:hover {
    color: #e0e0e0;
    border-color: rgba(255, 255, 255, 0.22);
}

.checkout-summary {
    flex: 1;
}

.checkout-title {
    font-size: 1.25rem;
    font-weight: 400;
    color: #f0f0f0;
    margin: 0 0 4px;
}

.checkout-price {
    font-size: 1.5rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    display: flex;
    align-items: baseline;
    gap: 4px;
    flex-wrap: wrap;
}

.checkout-period {
    font-size: 0.875rem;
    font-weight: 400;
    color: #888;
}

.checkout-subtext {
    font-size: 0.8125rem;
    color: #c0a053;
    font-weight: 400;
    margin-left: 6px;
}

.checkout-form-container {
    border-radius: 16px;
    overflow: hidden;
    min-height: 300px;
}

/* ── Responsive ────────────────────────────────────────── */
@media (max-width: 1080px) {
    .plans-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .plans-grid {
        grid-template-columns: 1fr;
    }

    .checkout-header {
        flex-direction: column;
        align-items: flex-start;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/SubscriptionPlans/Style/Plans.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,sDAAsD;IACtD,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kCAAkC;IAClC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2CAA2C;IAC3C;;;;KAIC;IACD,0CAA0C;IAC1C,uBAAuB;IACvB,sBAAsB;IACtB,wDAAwD;IACxD,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,sCAAsC;IACtC;;;;KAIC;IACD;;yCAEqC;AACzC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,qFAAqF;AACzF;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,mCAAmC;IACnC,0CAA0C;IAC1C,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,8EAA8E;IAC9E,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC;;;;KAIC;IACD,cAAc;IACd,gBAAgB;IAChB;;+CAE2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC;;;;KAIC;IACD;;8CAE0C;AAC9C;;AAEA,6DAA6D;AAC7D;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sDAAsD;IACtD,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,qDAAqD;AACzD;;AAEA;IACI,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,6DAA6D;AAC7D;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":["/* ── Plans page ────────────────────────────────────────── */\n.plans-page {\n    width: 100%;\n    max-width: 1280px;\n    margin: 0 auto;\n    padding: clamp(32px, 5vw, 64px) clamp(16px, 4vw, 40px);\n    box-sizing: border-box;\n}\n\n.plans-header {\n    text-align: center;\n    margin-bottom: 48px;\n}\n\n.plans-title {\n    font-size: clamp(1.6rem, 3vw, 2.2rem);\n    font-weight: 300;\n    color: #f4f4f4;\n    margin: 0 0 12px;\n    letter-spacing: 0.01em;\n}\n\n.plans-subtitle {\n    font-size: 0.9375rem;\n    color: #a0a0a0;\n    margin: 0;\n    line-height: 1.6;\n}\n\n.plans-error {\n    text-align: center;\n    color: #ff8080;\n    background: rgba(255, 80, 80, 0.1);\n    border: 1px solid rgba(255, 80, 80, 0.25);\n    border-radius: 10px;\n    padding: 12px 20px;\n    margin-bottom: 32px;\n    font-size: 0.9rem;\n}\n\n/* ── Plan grid ─────────────────────────────────────────── */\n.plans-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    align-items: start;\n}\n\n/* ── Plan card ─────────────────────────────────────────── */\n.plan-card {\n    display: flex;\n    flex-direction: column;\n    border-radius: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.09);\n    background: linear-gradient(\n        168deg,\n        rgba(54, 54, 58, 0.92) 0%,\n        rgba(28, 28, 32, 0.97) 100%\n    );\n    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4);\n    padding: 28px 24px 24px;\n    box-sizing: border-box;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    position: relative;\n}\n\n.plan-card:hover {\n    border-color: rgba(255, 255, 255, 0.16);\n    box-shadow: 0 20px 56px rgba(0, 0, 0, 0.5);\n}\n\n.plan-card--highlighted {\n    border-color: rgba(192, 159, 83, 0.55);\n    background: linear-gradient(\n        168deg,\n        rgba(64, 58, 42, 0.95) 0%,\n        rgba(32, 28, 18, 0.98) 100%\n    );\n    box-shadow:\n        0 20px 56px rgba(0, 0, 0, 0.5),\n        0 0 0 1px rgba(192, 159, 83, 0.2);\n}\n\n.plan-card--highlighted::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 48%;\n    height: 3px;\n    border-radius: 0 0 8px 8px;\n    background: linear-gradient(90deg, transparent, rgba(192, 159, 83, 0.9), transparent);\n}\n\n.plan-card--highlighted:hover {\n    border-color: rgba(192, 159, 83, 0.75);\n}\n\n/* Labels row (popular / badge) */\n.plan-card__labels {\n    display: flex;\n    gap: 8px;\n    min-height: 24px;\n    margin-bottom: 12px;\n}\n\n.plan-card__popular {\n    font-size: 0.6875rem;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: #c0a053;\n    background: rgba(192, 159, 83, 0.12);\n    border: 1px solid rgba(192, 159, 83, 0.3);\n    border-radius: 20px;\n    padding: 3px 10px;\n    display: inline-block;\n}\n\n.plan-card__badge {\n    font-size: 0.6875rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: #7dd69e;\n    background: rgba(80, 200, 120, 0.1);\n    border: 1px solid rgba(80, 200, 120, 0.25);\n    border-radius: 20px;\n    padding: 3px 10px;\n    display: inline-block;\n}\n\n.plan-card__name {\n    font-size: 1.25rem;\n    font-weight: 400;\n    color: #f0f0f0;\n    margin: 0 0 14px;\n    letter-spacing: 0.01em;\n}\n\n.plan-card__pricing {\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n    margin-bottom: 4px;\n}\n\n.plan-card__price {\n    font-size: 2rem;\n    font-weight: 600;\n    color: #ffffff;\n    letter-spacing: -0.02em;\n    line-height: 1;\n}\n\n.plan-card__period {\n    font-size: 0.875rem;\n    color: #888;\n    font-weight: 400;\n}\n\n.plan-card__subtext {\n    font-size: 0.8125rem;\n    color: #c0a053;\n    margin: 4px 0 12px;\n    font-weight: 500;\n}\n\n.plan-card__description {\n    font-size: 0.85rem;\n    color: #909090;\n    margin: 8px 0 20px;\n    line-height: 1.55;\n}\n\n/* Features list */\n.plan-card__features {\n    list-style: none;\n    margin: 0 0 24px;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    flex: 1;\n}\n\n.plan-card__feature {\n    display: flex;\n    align-items: flex-start;\n    gap: 9px;\n    font-size: 0.875rem;\n    color: #c8c8c8;\n    line-height: 1.45;\n}\n\n.plan-card__check {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n    margin-top: 1px;\n    color: #c0a053;\n}\n\n/* CTA button */\n.plan-card__cta {\n    width: 100%;\n    padding: 13px 20px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    background: rgba(255, 255, 255, 0.06);\n    color: #e8e8e8;\n    font-size: 0.9375rem;\n    font-weight: 500;\n    font-family: inherit;\n    cursor: pointer;\n    transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;\n    box-sizing: border-box;\n    margin-top: auto;\n}\n\n.plan-card__cta:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.25);\n}\n\n.plan-card__cta:active:not(:disabled) {\n    transform: translateY(1px);\n}\n\n.plan-card__cta:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.plan-card__cta--primary {\n    border-color: rgba(192, 159, 83, 0.55);\n    background: linear-gradient(\n        180deg,\n        rgba(192, 159, 83, 0.28) 0%,\n        rgba(160, 130, 65, 0.18) 100%\n    );\n    color: #faf6ee;\n    font-weight: 600;\n    box-shadow:\n        0 8px 24px rgba(0, 0, 0, 0.3),\n        inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.plan-card__cta--primary:hover:not(:disabled) {\n    border-color: rgba(192, 159, 83, 0.8);\n    background: linear-gradient(\n        180deg,\n        rgba(192, 159, 83, 0.38) 0%,\n        rgba(160, 130, 65, 0.26) 100%\n    );\n    box-shadow:\n        0 10px 28px rgba(0, 0, 0, 0.35),\n        inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n/* ── Footer ────────────────────────────────────────────── */\n.plans-footer {\n    text-align: center;\n    margin-top: 40px;\n    font-size: 0.8125rem;\n    color: #686868;\n    line-height: 1.6;\n}\n\n/* ── Checkout page ─────────────────────────────────────── */\n.checkout-page {\n    width: 100%;\n    max-width: 780px;\n    margin: 0 auto;\n    padding: clamp(32px, 5vw, 56px) clamp(16px, 4vw, 40px);\n    box-sizing: border-box;\n}\n\n.checkout-header {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    margin-bottom: 32px;\n    flex-wrap: wrap;\n}\n\n.checkout-back {\n    background: none;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 8px;\n    color: #a0a0a0;\n    font-size: 0.875rem;\n    font-family: inherit;\n    padding: 8px 14px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.checkout-back:hover {\n    color: #e0e0e0;\n    border-color: rgba(255, 255, 255, 0.22);\n}\n\n.checkout-summary {\n    flex: 1;\n}\n\n.checkout-title {\n    font-size: 1.25rem;\n    font-weight: 400;\n    color: #f0f0f0;\n    margin: 0 0 4px;\n}\n\n.checkout-price {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #ffffff;\n    margin: 0;\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n    flex-wrap: wrap;\n}\n\n.checkout-period {\n    font-size: 0.875rem;\n    font-weight: 400;\n    color: #888;\n}\n\n.checkout-subtext {\n    font-size: 0.8125rem;\n    color: #c0a053;\n    font-weight: 400;\n    margin-left: 6px;\n}\n\n.checkout-form-container {\n    border-radius: 16px;\n    overflow: hidden;\n    min-height: 300px;\n}\n\n/* ── Responsive ────────────────────────────────────────── */\n@media (max-width: 1080px) {\n    .plans-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 600px) {\n    .plans-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .checkout-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
